
<template>
    <main class="bodymain news" >
        <div v-html="mainContentNoNews" class="headerslider  "></div>
        <h1>News</h1>
        <article v-for="(post,index) in posts" :key="post.ID" >
          <a :href="localLink[index]">
            <span class="date" :datetime="post.date_gmt">{{myDate[index]}}</span>
            <h1 v-html="post.title.rendered"></h1>
          </a>
          <main v-html="post.content.rendered">
          </main>
        </article>
        <NewsPagination :pagination="pagination" :key="pagination.total"/>
    </main>
</template>
  
<script>
    import moment from 'moment';
    import VueAllInitMixin from '@/mixins/VueAllInit.js';
    import NewsPagination from '@/components/NewsPagination.vue';
//import func from './vue-temp/vue-editor-bridge';
    export default {
        mixins: [VueAllInitMixin],
        data() {
            return {
                mainContent:'',
                //n: Number, // V For Pages
                postsUrl: '/wp/v2/posts',
                posts: [],
                postsData: {
                    per_page: 3,
                    page: 1
                },
                pagination: {
                    currentPage:  Number.parseInt(this.$route.params.pagenum),
                    prevPage: 'Vorher',
                    nextPage: '',
                    totalPages: Number,
                    from: '',
                    to: '',
                    total: '',
                },
            }
        },
        components: {
            //'pagination': pagination
            NewsPagination
        },
        watch:{
            '$route' (to, from) {
                this.getPosts();
            }
        },
        computed:{
            mainContentNoNews: function() {
                let myOP=this.mainContent;
                myOP = myOP.replaceAll ( "<h1>" ,"<span class='hidden'>");
                myOP = myOP.replaceAll ( "</h1>", "</span>");
                return myOP;
            },
            myDate: function(){
                return this.posts.map(function(post) {
                    //let pattern = 'https://'+this.globalHost+'/jd-news/';
                    let me =  moment(post.date_gmt).format("DD MMM YYYY");
                    return me;
                });

            },
            localLink: function() {
                return this.posts.map(function(post) {
                    //let pattern = 'https://'+this.globalHost+'/jd-news/';
                    let pattern = 'https://divalovers.com/jd-news/';
                    return post.link.replaceAll(pattern, '/jd-news/');
                });
            }
        },
        created() {
            this.getPosts();
            this.getNewsPageContent();
        },
        updated (){
            this.VueAllInit();
        },
        beforeUpdate: function(){
          //this.posts=[]
        },
        methods: {
            getNewsPageContent() {
                this.$http.get('wp/v2/pages?slug=news' )
                    .then( (response) => {
                    this.mainContent = response.data[0].content.rendered;
                }).catch(function (error) {
                    console.log(error);
                });
            },
            getPosts() {
                //
                this.posts=[];
                // Axios Call has to have 
                // axios.get(this.postsUrl, {params: this.postsData})
                this.postsData.page=this.$route.params.pagenum;
                //console.log("Pagenum: "+this.postsData.page);
                this.$http.get(this.postsUrl, {params: this.postsData})
                    .then((response) => {
                        this.posts = response.data;
                        this.configPagination(response.headers);
                    })
                    .catch( (error) => {
                        console.log(error);
                    });
            },
            configPagination(headers) {
                this.pagination.total = +headers['x-wp-total'];
                //this.pagination.totalPages = +headers['x-wp-totalpages'];
                this.pagination.totalPages = headers['x-wp-totalpages'];
                //console.log(this.pagination.totalPages);
                //https://developer.wordpress.org/rest-api/using-the-rest-api/pagination/
            }
        }
    }
</script>
